export const MAPPING_SIDE = Object.freeze({
  SOURCE: "source",
  DESTINATION: "destination",
})

export const { SOURCE: SOURCE_SIDE, DESTINATION: DESTINATION_SIDE } = MAPPING_SIDE
